import React, { useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import LINKS_QUERIES from '../graphql/links/queries';
import { Table } from 'antd';
import { DateTime } from 'luxon';


const ScreenContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: nowrap;
  min-height: 100vh;
`;

const FormContainer = styled.div`
  flex-grow: 4;
  display: flex;
  flex-direction: column;
  padding: 0 3vw;
  margin: 50px 0px;
`;

const FormHeading = styled.h1`
  font-family: LexiaAd;
`;

const LinksMessage = styled.span`
  font-family: LexiaAd;
  font-size: 15px;
  color: green;
`;

const FormSubheading = styled.div`
  display: flex;
  width: 80%;
  margin-bottom: 15px;
  text-align: justify;
  text-justify: inter-word;
`;

const Title = styled.span`
  font-family: LexiaAd;
  font-size: 14px;
`;

const FormScreen = () => {

  const [links, setLinks] = useState([]);
  const [sections, setSections] = useState([]);
  const [called, setCalled] = useState(false);


  // Queries
  useQuery(LINKS_QUERIES.LINKS_GET, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      setCalled(true);
      setLinks(
        data?.getLinksResponse?.map(link => ({
          id: link.id,
          name: link.name,
          url: link.type === 'url' ? link.url : link.file,
          comments: link.comments,
          created: link.created,
          modified: link.modified
        }))
      );
    },
  });

  useQuery(LINKS_QUERIES.SECTIONS_GET, {
    fetchPolicy: 'network-only',
    onCompleted: data => {
      setCalled(true);
      let flatSections = [];
      data?.getSectionsResponse?.forEach(s => {
        // We only add the sections, if it has children
        if (s.resources.length > 0){
          flatSections.push({
            id: s.id,
            name: s.name,
            modified: null,
            comments: null,
            parent: true,
          });
        }
        s.resources.forEach(resource => {
          flatSections.push({
            id: resource.id,
            name: resource.friendly_name,
            modified: resource.modified,
            comments: resource.comments,
            url: resource.type === 'url' ? resource.url : resource.file,
            parent: false,
          });
        });

      });
      setSections(flatSections);
    },
  });

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      // eslint-disable-next-line
      render: (text, record) => record.parent ? <Title>{text}</Title> : (<a key={record.id} href={record.url} target="_blank" rel="noreferrer">{record.name}</a>)
    },
    {
      title: 'Date',
      dataIndex: 'modified',
      key: 'modified',
      width: 150,
      render: (text, record) => record.parent ? null : (DateTime.fromISO(text).toFormat('DDD'))
    },
    {
      title: 'Comments',
      dataIndex: 'comments',
      key: 'comments',
      render: (text, record) => record.parent ? null : (text ? text : '-')
    },
  ];



  return (
    <>
      <ScreenContainer>
        <FormContainer>
          <FormHeading>
            Download Resources
          </FormHeading>
          <FormSubheading>Available resources for download including script, and profile, templates, EULA, admin guide, and more.</FormSubheading>
          {called && links.length === 0 && sections.length == 0 && <LinksMessage>No links found.</LinksMessage>}
          <div style={{ marginTop: '10px' }}>
            {links.length > 0 && <Table dataSource={links} columns={columns} bordered={false} pagination={false} />}
            {sections.length > 0 && <Table dataSource={sections} columns={columns} bordered={false} pagination={false} showHeader={links.length == 0} />}
          </div>
        </FormContainer>
      </ScreenContainer>
    </>);
};

export default FormScreen;